export default __webpack_public_path__ + "static/media/Rewards page.357d40a5.jpg";